import {AppError} from '@core/models/AppError';
import {NotificationModalComponent} from '../components/notification-modal/notification-modal.component';
import {INotificationDetails} from '../interfaces/INotificationDetails';

export const commonError = (details: INotificationDetails) => new AppError<NotificationModalComponent, INotificationDetails>({
  component: NotificationModalComponent,
  payload: details
});
